var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSplit = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31C4C0",
    d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    d: "M11.55 6.45a.45.45 0 0 1 .9 0v11.1a.45.45 0 0 1-.9 0zm4.776 5.988h-2.531A.434.434 0 0 1 13.35 12a.434.434 0 0 1 .445-.438h2.531l-1.268-1.249a.4.4 0 0 1-.128-.307.46.46 0 0 1 .128-.306.46.46 0 0 1 .317-.137.42.42 0 0 1 .317.126l2.036 2.004a.4.4 0 0 1 .094.143.48.48 0 0 1 0 .328.4.4 0 0 1-.094.143l-2.036 2.004a.42.42 0 0 1-.317.126.46.46 0 0 1-.317-.137.46.46 0 0 1-.128-.306.4.4 0 0 1 .128-.307zm-8.652 0h2.531A.434.434 0 0 0 10.65 12a.434.434 0 0 0-.445-.438H7.674l1.268-1.249a.4.4 0 0 0 .128-.307.46.46 0 0 0-.128-.306.46.46 0 0 0-.317-.137.42.42 0 0 0-.317.126l-2.036 2.004a.4.4 0 0 0-.094.143.5.5 0 0 0-.028.164q0 .087.028.164.027.077.094.143l2.036 2.004q.133.132.317.126a.46.46 0 0 0 .317-.137.46.46 0 0 0 .128-.306.4.4 0 0 0-.128-.307z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSplit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/split.50a1342a.svg";